<div id="{{fieldConfig.fieldKey + '-datePicker'}}"
     class="material__datefield"
     [ngClass]="{
        'predefined-value': predefinedStyleEnabled,
        'material__datefield--async': isAsync,
        'material__datefield--manual-input': manualInputAllowed,
        'material-year-picker': isYearPicker
    }">

    <div *ngIf="loadingDropdownVisible" class="material__datefield__loading-dropdown">
        <app-dropdown [content]="loadingDropdownContent">
            <ng-template #loadingDropdownContent>
                <span>{{ 'SELECT_COMPONENT.loadingText' | translate }}</span>
            </ng-template>
        </app-dropdown>
    </div>

    <div style="flex: auto">
        <mat-form-field [floatLabel]="floatLabel"
                        (click)="open(false)">
            <input matInput
                   #input
                   class="date-picker-input"
                   id="{{fieldConfig.fieldKey + 'Input'}}"
                   [readonly]="readonly"
                   [formControl]="control"
                   [placeholder]="fieldConfig.caption | translate"
                   [matDatepicker]="picker"
                   [min]="minDate"
                   [max]="maxDate"
                   (focusin)="onFocusIn()"
                   (focusout)="onFocusOut()"
                   (keyup)="onInputKeyup($event)"
                   (dateChange)="changeDate($event)">

            <mat-datepicker-toggle matSuffix
                                   [for]="picker">
                <mat-icon *ngIf="!datepickerToggleImage"
                          matDatepickerToggleIcon
                          (click)="onClick($event)"
                          class="mat-icon-datepicker"
                >{{ datepickerToggleIcon }}</mat-icon>
                <img *ngIf="datepickerToggleImage"
                     matDatepickerToggleIcon
                     (click)="onClick($event)"
                     [src]="datepickerToggleImage"
                     alt="">
            </mat-datepicker-toggle>

            <mat-datepicker #picker
                            [touchUi]="isMobile"
                            [startAt]="startAt"
                            [startView]="startView"
                            (opened)="onOpen()"
                            (closed)="onClose()"
                            (yearSelected)="onYearSelected($event)">
            </mat-datepicker>

            <span *ngIf="typeToSearchTextVisible"
                  class="material__datefield__type-to-search-text">
                {{ typeToSearchText | translate }}
            </span>

            <mat-hint *ngIf="verificationHintVisible" class="predefined-value__color">
                {{'HINTS.verificationRequired' | translate}}
            </mat-hint>
        </mat-form-field>

        <mat-error *ngIf="errorsMap.get(fieldConfig.fieldKey)">{{ (context + '.' + fieldConfig.fieldKey + '.' +
            errorsMap.get(fieldConfig.fieldKey))|translate}}
        </mat-error>
    </div>

    <div class="desc-icon">
        <app-tooltip-icon *ngIf="tooltipIconVisible"
                          [description]="fieldConfig.description">
        </app-tooltip-icon>

        <app-information-icon class="information-icon" *ngIf="informationIconVisible"
                              [information]="fieldConfig.predefined.additionalInfo | additionalInfo"
                              [description]="fieldConfig.description | translate">
        </app-information-icon>
    </div>
</div>
